import container from './components/Container'
import store from './store'

export { store }

export default container